import { derived, type Readable } from 'svelte/store';
import type { ComponentType } from 'svelte';

import { AdvancedCard, AdvancedCardV2 } from '@Shelly/shelly-design-system';

import { showNewLayout } from 'src/stores/toDelete/new_layout';

/**
 * The AdvancedCard flavour for the active layout: `AdvancedCardV2` for the new
 * layout, `AdvancedCard` for the legacy layout. Both share the same prop/slot
 * API, so consume it via `<svelte:component this={$advancedCardComponent} …>`
 * to keep layout-aware cards DRY.
 */
export const advancedCardComponent: Readable<ComponentType> = derived(showNewLayout, ($showNewLayout) =>
	$showNewLayout ? AdvancedCardV2 : AdvancedCard,
);
